import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { key: 3 }
const _hoisted_5 = { key: 4 }
const _hoisted_6 = { key: 5 }
const _hoisted_7 = { key: 6 }
const _hoisted_8 = { key: 7 }
const _hoisted_9 = { key: 8 }
const _hoisted_10 = { key: 9 }
const _hoisted_11 = { key: 10 }
const _hoisted_12 = { key: 11 }
const _hoisted_13 = { key: 12 }
const _hoisted_14 = { key: 13 }
const _hoisted_15 = { key: 14 }
const _hoisted_16 = { key: 15 }
const _hoisted_17 = { key: 16 }
const _hoisted_18 = { key: 17 }
const _hoisted_19 = { key: 18 }
const _hoisted_20 = { key: 19 }
const _hoisted_21 = { key: 20 }
const _hoisted_22 = { key: 21 }
const _hoisted_23 = { key: 22 }
const _hoisted_24 = { key: 23 }
const _hoisted_25 = { key: 24 }
const _hoisted_26 = { key: 25 }
const _hoisted_27 = { key: 26 }
const _hoisted_28 = { key: 27 }
const _hoisted_29 = { key: 28 }
const _hoisted_30 = { key: 29 }
const _hoisted_31 = { key: 30 }
const _hoisted_32 = { key: 31 }
const _hoisted_33 = { key: 32 }
const _hoisted_34 = { key: 33 }
const _hoisted_35 = { key: 34 }
const _hoisted_36 = { key: 35 }
const _hoisted_37 = { key: 36 }
const _hoisted_38 = { key: 37 }
const _hoisted_39 = { key: 38 }
const _hoisted_40 = { key: 39 }
const _hoisted_41 = { key: 40 }
const _hoisted_42 = { key: 41 }
const _hoisted_43 = { key: 42 }
const _hoisted_44 = { key: 43 }
const _hoisted_45 = { key: 44 }
const _hoisted_46 = { key: 45 }
const _hoisted_47 = { key: 46 }
const _hoisted_48 = { key: 47 }
const _hoisted_49 = { key: 48 }
const _hoisted_50 = { key: 49 }
const _hoisted_51 = { key: 50 }
const _hoisted_52 = /*#__PURE__*/_createTextVNode(" 预览 ")
const _hoisted_53 = /*#__PURE__*/_createTextVNode(" 下载 ")

import { withDefaults } from "vue";
import { downloadTableFile } from "@/utils/download";
import { manual } from "@/api/api";
import { getFileType } from "@/utils/type";


export default /*#__PURE__*/_defineComponent({
  props: {
    tableData: { default: () => [] },
    columns: { default: () => [] }
  },
  setup(__props: any) {



const handlePreview = (path: string) => {
  const type = getFileType(path);
  if (type == 3 || type == 6 || type == 7) {
    window.open(`https://view.officeapps.live.com/op/view.aspx?src=${path}`);
  } else {
    window.open(path);
  }
};
const download = async (filename: string, Id: number | string) => {
  downloadTableFile(filename, Id as string);
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createBlock(_component_a_table, {
    class: "detail-table",
    rowClassName: "sign-table-tr",
    pagination: false,
    dataSource: __props.tableData,
    columns: __props.columns
  }, {
    FileName: _withCtx(({ text: record }) => [
      (record.AccessoryType == '211' && record.FileUrl)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, "财务预算"))
        : (record.AccessoryType == '212' && record.FileUrl)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, " 开业预算 "))
          : (record.AccessoryType == '221' && record.FileUrl)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, " 借款协议 "))
            : (record.AccessoryType == '222' && record.FileUrl)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, " 合同会签 "))
              : (record.AccessoryType == '311' && record.FileUrl)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, " 选址 "))
                : (record.AccessoryType == '321' && record.FileUrl)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, " 房屋租赁合同 "))
                  : (record.AccessoryType == '3211' && record.FileUrl)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, " 房屋租赁合同回传文件 "))
                    : (record.AccessoryType == '322' && record.FileUrl)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, " 房产证复印件 "))
                      : (record.AccessoryType == '323' && record.FileUrl)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, " 租赁备案 "))
                        : (record.AccessoryType == '324' && record.FileUrl)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, " 授权委托书 "))
                          : (record.AccessoryType == '325' && record.FileUrl)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, " 物业协议 "))
                            : (record.AccessoryType == '331' && record.FileUrl)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, " 房屋装修协议 "))
                              : (record.AccessoryType == '3311' && record.FileUrl)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, " 房屋装修协议回传文件 "))
                                : (record.AccessoryType == '332')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, "办公用品采购协议"))
                                  : (record.AccessoryType == '3321' && record.FileUrl)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, " 办公用品采购协议回传文件 "))
                                    : (record.AccessoryType == '511' && record.FileUrl)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, " 分子公司工商申请表 "))
                                      : (record.AccessoryType == '521' && record.FileUrl)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, " 资料提供申请单 "))
                                        : (record.AccessoryType == '5211' && record.FileUrl)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, " 资料提供申请单补充 "))
                                          : (record.AccessoryType == '522' && record.FileUrl)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, " 用印、用证审批表 "))
                                            : (record.AccessoryType == '5221' && record.FileUrl)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_20, " 用印、用证审批表补充 "))
                                              : (record.AccessoryType == '541' && record.FileUrl)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, " 工商营业执照正本 "))
                                                : (record.AccessoryType == '542' && record.FileUrl)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, " 工商营业执照副本 "))
                                                  : (record.AccessoryType == '543' && record.FileUrl)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, " 负责人身份证复印件 "))
                                                    : (record.AccessoryType == '544' && record.FileUrl)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, " 人力资源许可证扫描件或备案回执 "))
                                                      : (record.AccessoryType == '545' && record.FileUrl)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, " 开业至今工商调档材料 "))
                                                        : (record.AccessoryType == '546' && record.FileUrl)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, " 印鉴留存卡 "))
                                                          : (record.AccessoryType == '547' && record.FileUrl)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_27, " 印章、证照保管承诺书 "))
                                                            : (record.AccessoryType == '621' && record.FileUrl)
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_28, " 税务受理结果反馈单 "))
                                                              : (record.AccessoryType == '622' && record.FileUrl)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_29, " 申领税控设备回执单 "))
                                                                : (record.AccessoryType == '631' && record.FileUrl)
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, " 开户许可证 "))
                                                                  : (record.AccessoryType == '632' && record.FileUrl)
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, " 银行预留印鉴卡 "))
                                                                    : (record.AccessoryType == '633' && record.FileUrl)
                                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, " 开户回执资料（全套） "))
                                                                      : (record.AccessoryType == '721' && record.FileUrl)
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, " 客户及人选流程交接表 "))
                                                                        : (record.AccessoryType == '811' && record.FileUrl)
                                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_34, " 房屋图片 "))
                                                                          : (record.AccessoryType == '1311' && record.FileUrl)
                                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_35, " 纳税人迁移通知书 "))
                                                                            : (record.AccessoryType == '1312' && record.FileUrl)
                                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_36, " 税务登记(跨区、区内)迁移申请审批表 "))
                                                                              : (record.AccessoryType == '921' && record.FileUrl)
                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_37, " 房屋装修协议 "))
                                                                                : (record.AccessoryType == '9211' && record.FileUrl)
                                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, " 房屋装修协议(回传) "))
                                                                                  : (record.AccessoryType == '922' && record.FileUrl)
                                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, " 办公用品采购协议 "))
                                                                                    : (record.AccessoryType == '9221' && record.FileUrl)
                                                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_40, " 办公用品采购协议(回传) "))
                                                                                      : (record.AccessoryType == '931' && record.FileUrl)
                                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, " 房屋租赁合同 "))
                                                                                        : (record.AccessoryType == '932' && record.FileUrl)
                                                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_42, " 房产证复印件 "))
                                                                                          : (record.AccessoryType == '911' && record.FileUrl)
                                                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_43, " 租赁备案 "))
                                                                                            : (record.AccessoryType == '912' && record.FileUrl)
                                                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_44, " 授权委托书 "))
                                                                                              : (record.AccessoryType == '913' && record.FileUrl)
                                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_45, " 物业协议 "))
                                                                                                : (record.AccessoryType == '1011' && record.FileUrl)
                                                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_46, " 资料提供申请表 "))
                                                                                                  : (record.AccessoryType == '1111' && record.FileUrl)
                                                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_47, " 用印、用证审批表 "))
                                                                                                    : (record.AccessoryType == '1211' && record.FileUrl)
                                                                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_48, " 其他需协助的文件 "))
                                                                                                      : (record.AccessoryType == '1012' && record.FileUrl)
                                                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_49, " 资料提供申请单补充 "))
                                                                                                        : (record.AccessoryType == '1112' && record.FileUrl)
                                                                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_50, " 用印、用证审批表补充 "))
                                                                                                          : (record.AccessoryType == '9311' && record.FileUrl)
                                                                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_51, " 房屋租赁合同(回传) "))
                                                                                                            : _createCommentVNode("", true)
    ]),
    actionBtn: _withCtx(({ text: record }) => [
      (record.FileUrl)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _withDirectives(_createVNode(_component_a_button, {
              type: "link",
              style: {"padding":"0"},
              onClick: ($event: any) => (handlePreview(record.FileUrl as string))
            }, {
              default: _withCtx(() => [
                _hoisted_52
              ]),
              _: 2
            }, 1032, ["onClick"]), [
              [_vShow, !record.FileUrl.includes('.zip')]
            ]),
            _createVNode(_component_a_button, {
              type: "link",
              class: _normalizeClass([
            record.FileUrl.includes('.zip') ? 'preview-none' : 'preview-block',
          ]),
              style: {"padding-right":"0px","padding-bottom":"0","padding-top":"0"},
              onClick: ($event: any) => (
            download(record.FileName as string, record.Id as number)
          )
            }, {
              default: _withCtx(() => [
                _hoisted_53
              ]),
              _: 2
            }, 1032, ["class", "onClick"])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["dataSource", "columns"]))
}
}

})